<div class="lottie-animation flex flex-col w-full items-center justify-center">
  <ng-lottie class="w-1/4 mb--10" [options]="options" (animationCreated)="onAnimate($event)"></ng-lottie>
  <p class="text-xl">Cette page est en cours de construction.</p>
</div>
